<template>
  <div class="edit-setting-check-box">
    <span class="common-label">モバイル画像表示</span>
      <div class="common-checkbox">
        <input
          :id="idName"
          type="checkbox"
          :checked="isChecked"
          @change="onChangeTarget($event.target.checked)"
        />
        <label :for="idName"></label>
        <span class="common-label">画面幅フィット</span>
    </div>
  </div>
</template>

<script>
export default {
  props: [
    'target',
    'value',
  ],
  computed: {
    isChecked () {
      return Boolean(this.value)
    },
    idName () {
      return this.target.replace(/_/g, '-')
    },
  },
  methods: {
    onChangeTarget (checked) {
      this.$emit('update', [{ prop: this.target, value: Number(checked) }])
    },
  },
}
</script>
